import React from 'react';
import classNames from 'classnames';
import { Box } from "@chakra-ui/react";
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './monitor-list.css';
import { setVariableList } from '../../../store/api-state'


class VariableList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sensorsList: [{
                name: 'get_tof_distance',
                index: 0
            },
            {
                name: 'get_roll',
                index: 0
            }]
        };
        // this.componentReady = React.createRef();
    }

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState) {
        // // return nextState
        // console.log(nextState.sensorsList, nextProps.monitors, this.state.sensorsList, 
        //     nextState.sensorsList[0].index !== nextProps.monitors[0].index ||
        //     nextState.sensorsList[1].index !== nextProps.monitors[1].index || 
        //     nextState.sensorsList[0].index !== this.state.sensorsList[0].index || 
        //     nextState.sensorsList[1].index !== this.state.sensorsList[1].index
        // )
        return nextState.sensorsList[0].index !== nextProps.monitors[0].index ||
            nextState.sensorsList[1].index !== nextProps.monitors[1].index ||
            nextState.sensorsList[0].index !== this.state.sensorsList[0].index || 
            nextState.sensorsList[1].index !== this.state.sensorsList[1].index
        // nextState.sensorsList[2].index !== nextProps.monitors[2].index || 
        // nextState.sensorsList[3].index !== nextProps.monitors[3].index
    }

    componentDidUpdate(prevProps, prevState) {
        this.setState(
            {
                sensorsList: this.props.monitors
            }
        )
    }

    componentWillUnmount() {
        // recycle the DOM nodes
        // this.props.segments.forEach(segment => {
        //     segment.ref.current.remove();
        // });
        // this.componentReady = null;
    }
    getDaultMessage(type) {
        switch (type) {
            case 'get_tof_distance':
                return 'Sensors: ToF detection distance'
                break;
            case 'get_roll':
                return 'Sensors: loudness'
                break;
            case 'get_pitch':
                return 'Sensors: get pitch value'
                break;
            case 'get_yaw':
                return 'Sensors: get yaw value'
                break;
            default:
                return null;
        }
    }

    render() {
        const {
            intl
        } = this.props;
        return (
            <Box
                // Use static `monitor-overlay` class for bounds of draggables
                className="monitorList monitor-overlay"
            >

                <Box className="variableContant">
                    {this.state.sensorsList.map((i, index) => (
                        <React.Fragment key={index} >
                            <div className="variableList">
                                <div className="label">
                                    <FormattedMessage
                                        id={i.name}
                                        defaultMessage={this.getDaultMessage(i.name)}
                                    />
                                </div>
                                <div className="value">{i.index}</div>
                            </div>
                        </React.Fragment>
                    ))}
                </Box>

            </Box>
        );
    }
}

VariableList.propTypes = {
    isConnected: PropTypes.bool,
    monitors: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            index: PropTypes.number
        })
    )
};
const mapStateToProps = state => ({
    isConnected: state.connectStore.isConnected
});

const mapDispatchToProps = dispatch => ({
    setVariableList: data => dispatch(setVariableList(data))
});
// export default VariableList;

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(VariableList);
